import http from "@/http-common";

/* eslint-disable */
class StationForSystemDataService {
    
    checkStationInUse(data : any): Promise<any>{
        return http.api.post("/checkStationInUse/",data);
    }
    deleteStationCodeData(data: any): Promise<any> {
        return http.api.post("/deleteStationCodeData/", data);
    }
}

export default new StationForSystemDataService();
